import { render, staticRenderFns } from "./TableApi.vue?vue&type=template&id=27e5414a&"
import script from "./TableApi.vue?vue&type=script&lang=js&"
export * from "./TableApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports